import { lazy, Suspense } from 'react'
import { Routes, Route } from 'react-router-dom'
import { Toaster } from 'react-hot-toast'
import Layout from './components/Layout'
import HomePage from './pages/HomePage'
import BuscaPage from './pages/BuscaPage'
import TemaPage from './pages/TemaPage'
import VideoaulaPage from './pages/VideoaulaPage'
import CadernoPage from './pages/CadernoPage'
import PerfilPage from './pages/PerfilPage'
import LoginPage from './pages/LoginPage'
import RegisterPage from './pages/RegisterPage'
import OnboardingPage from './pages/OnboardingPage'
import RevisaoPage from './pages/RevisaoPage'
import MateriaPage from './pages/MateriaPage'
import AdminPage from './pages/AdminPage'
import InstituicaoPage from './pages/InstituicaoPage'
import ConvitePage from './pages/ConvitePage'
import RecomendarPage from './pages/RecomendarPage'

const TutorPage = lazy(() => import('./pages/TutorPage'))

function App() {
  return (
    <>
      <Toaster
        position="top-center"
        toastOptions={{
          duration: 3000,
          style: {
            background: '#1a1a1a',
            color: '#fff',
            borderRadius: '10px'
          }
        }}
      />
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route path="/cadastro" element={<RegisterPage />} />
        <Route path="/onboarding" element={<OnboardingPage />} />
        <Route path="/convite/:token" element={<ConvitePage />} />

        <Route element={<Layout />}>
          <Route path="/" element={<HomePage />} />
          <Route path="/index.html" element={<HomePage />} />
          <Route path="/explorar" element={<BuscaPage />} />
          <Route path="/busca" element={<BuscaPage />} />
          <Route path="/materia/:id" element={<MateriaPage />} />
          <Route path="/tema/:id" element={<TemaPage />} />
          <Route path="/videoaula/youtube/:youtubeId" element={<VideoaulaPage />} />
          <Route path="/recomendacao/:recommendationId" element={<VideoaulaPage />} />
          <Route path="/historico/:historyId" element={<VideoaulaPage />} />
          <Route path="/videoaula/:id" element={<VideoaulaPage />} />
          <Route path="/caderno" element={<CadernoPage />} />
          <Route path="/revisao" element={<RevisaoPage />} />
          <Route path="/perfil" element={<PerfilPage />} />
          <Route path="/recomendar" element={<RecomendarPage />} />
          <Route path="/tutor" element={<Suspense fallback={<p className="card text-sm text-gray-500">Carregando Tutor IA...</p>}><TutorPage /></Suspense>} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/instituicao" element={<InstituicaoPage />} />
        </Route>
      </Routes>
    </>
  )
}

export default App
